import React from 'react';

import AvaliacaoDesempenhoLista from 'Component/AvaliacaoDesempenho';
import Buscando from 'Component/Buscando';
import Cabecalho from 'Component/Cabecalho';
import LayoutDefault from 'Component/Layout';
import { useRecuperarVinculosEmpregaticiosQuery } from 'View/Service/Default/VinculosEmpregaticios';

const Default = (): React.ReactElement => {
  const { data: { vinculos } = {}, isLoading } =
    useRecuperarVinculosEmpregaticiosQuery({
      finder: 'prazoDeExperienciaVencendoParaAvaliacaoDesempenho',
      contain: ['Usuarios', 'Empresas'],
      limit: 200,
      options: { status: 1 },
      sort: 'Usuarios.nome',
    });

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Avaliação de desempenho"
        descricao="Faça a avaliação em lote dos funcionários que ainda não fez"
      />
      <Buscando exibir={isLoading} />
      <React.Fragment>
        <div className="bg-white shadow-sm rounded">
          {vinculos?.map((folha) => (
            <AvaliacaoDesempenhoLista
              key={`${folha.id}-${folha.modificado}`}
              dados={folha}
            />
          ))}
        </div>
      </React.Fragment>
    </LayoutDefault>
  );
};

export default Default;
